__turbopack_context__.v({
  "banner": "h5zI6W_banner",
  "description": "h5zI6W_description",
  "price-banner": "h5zI6W_price-banner",
  "single-line": "h5zI6W_single-line",
  "small": "h5zI6W_small",
});
